import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Phone, Mail, Facebook, Instagram } from 'lucide-react';
import { mockData } from '../data/mock';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  const location = useLocation();
  const isHomePage = location.pathname === '/';

  // Liens de section : <Link> réel (SEO), scroll fluide seulement si déjà sur /
  // Sinon on laisse react-router naviguer (pas de rechargement complet)
  const handleSectionClick = (e, sectionId) => {
    if (!isHomePage) return;
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  const sectionLinks = [
    { id: 'accueil', label: 'Accueil' },
    { id: 'services', label: 'Services' },
    { id: 'valeurs', label: 'Pourquoi nous' },
    { id: 'realisations', label: 'Réalisations' },
  ];

  return (
    <footer className="footer-main">
      <div className="container">
        <div className="footer-content" data-aos="fade-up">
          {/* Colonne 1 - À propos */}
          <div className="footer-column">
            <h3 className="footer-title">{mockData.company.name}</h3>
            <p className="footer-text">
              Constructeur de maisons individuelles en Provence depuis plus de 20 ans. 
              Nous accompagnons nos clients de A à Z dans leur projet de construction.
            </p>
            <div className="footer-social">
              <a href="https://www.facebook.com/p/Bouhdel-Constructeur-de-maisons-individuelles-100086627212377/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="https://www.instagram.com/bouhdel_/" target="_blank" rel="noopener noreferrer" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
            </div>
          </div>

          {/* Colonne 2 - Liens rapides */}
          <div className="footer-column">
            <h4 className="footer-column-title">Navigation</h4>
            <ul className="footer-links">
              {sectionLinks.map(link => (
                <li key={link.id}>
                  <Link to={`/#${link.id}`} onClick={(e) => handleSectionClick(e, link.id)} className="footer-link">
                    {link.label}
                  </Link>
                </li>
              ))}
              <li><Link to="/histoire" className="footer-link">Notre histoire</Link></li>
              <li><Link to="/ccmi" className="footer-link">Le CCMI</Link></li>
              <li><Link to="/re2020" className="footer-link">Norme RE2020</Link></li>
              <li><Link to="/realisations" className="footer-link">Nos réalisations</Link></li>
              <li>
                <Link to="/#contact" onClick={(e) => handleSectionClick(e, 'contact')} className="footer-link">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Colonne 3 - Services */}
          <div className="footer-column">
            <h4 className="footer-column-title">Nos services</h4>
            <ul className="footer-links">
              <li className="footer-link-static">Recherche de terrain</li>
              <li className="footer-link-static">Construction clé en main</li>
              <li className="footer-link-static">Accompagnement financement</li>
              <li className="footer-link-static">Garanties & assurances</li>
              <li className="footer-link-static">Suivi de chantier</li>
            </ul>
          </div>

          {/* Colonne 4 - Contact */}
          <div className="footer-column">
            <h4 className="footer-column-title">Contact</h4>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <Phone size={18} />
                <span>{mockData.company.phone}</span>
              </li>
              <li className="footer-contact-item">
                <Mail size={18} />
                <span>{mockData.company.email}</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Barre du bas */}
        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {currentYear} {mockData.company.name}. Tous droits réservés.
          </p>
          <div className="footer-legal">
            <Link to="/mentions-legales" className="footer-legal-link">Mentions légales</Link>
            <span className="footer-separator">|</span>
            <Link to="/politique-confidentialite" className="footer-legal-link">Politique de confidentialité</Link>
            <span className="footer-separator">|</span>
            <Link to="/cgu" className="footer-legal-link">CGU</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
